import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BeneficiarAdd, BeneficiarUpdate } from './beneficiari.interface';
import { catchError, map, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class BeneficiariService {
    private token!: string;
    private httpOptions: any;

    private basePath = environment.interop.basePath;

    private fileUploadUrl = this.basePath + environment.interop.dgaspc.activitati.fileUpload;
    private fileUploadBase64Url = this.basePath + environment.interop.dgaspc.activitati.fileUploadBase64;
    public tempFileDownloadUrl = this.basePath + environment.interop.dgaspc.activitati.tempFileDownload;

    private getBeneficiarUrl = this.basePath + environment.interop.dgaspc.activitati.copii.getCopil;
    private getBeneficiariUrl = this.basePath + environment.interop.dgaspc.activitati.copii.getCopii;
    private storeBeneficiarUrl = this.basePath + environment.interop.dgaspc.activitati.copii.storeCopil;
    private updateBeneficiarUrl = this.basePath + environment.interop.dgaspc.activitati.copii.updateCopil;
    private deleteBeneficiarUrl = this.basePath + environment.interop.dgaspc.activitati.copii.deleteCopil;

    private storeLocalizareUrl = this.basePath + environment.interop.dgaspc.activitati.copii.storeLocalizare;
    private updateLocalizareUrl = this.basePath + environment.interop.dgaspc.activitati.copii.updateLocalizare;
    private deleteLocalizareUrl = this.basePath + environment.interop.dgaspc.activitati.copii.deleteLocalizare;
    private storeRelatieUrl = this.basePath + environment.interop.dgaspc.activitati.copii.storeRelatie;
    private updateRelatieUrl = this.basePath + environment.interop.dgaspc.activitati.copii.updateRelatie;
    private deleteRelatieUrl = this.basePath + environment.interop.dgaspc.activitati.copii.deleteRelatie;
    private storeFilesUrl = this.basePath + environment.interop.dgaspc.activitati.copii.storeFiles;
    private updateFilesUrl = this.basePath + environment.interop.dgaspc.activitati.copii.updateFiles;
    public downloadFileUrl = this.basePath + environment.interop.dgaspc.activitati.copii.downloadFile;
    public downloadChangesUrl = this.basePath + environment.interop.dgaspc.activitati.copii.downloadChanges;
    public downloadFisaUrl = this.basePath + environment.interop.dgaspc.activitati.copii.downloadFisa;

    private postMessageUrl = this.basePath + environment.interop.dgaspc.activitati.copii.postMessage;
    private exportHistoryUrl = this.basePath + environment.interop.dgaspc.activitati.copii.downloadHistory;
    private internalSearchUrl = this.basePath + environment.interop.dgaspc.activitati.copii.internalSearch;

    constructor(private http: HttpClient) { }

    fileUpload(formData: FormData) {
        return this.http.post<{ data: any }>(this.fileUploadUrl, formData);
    }

    getBeneficiar(id: number) {
        return this.http.get(this.getBeneficiarUrl + id);
    }

    addBeneficiar(beneficiar: BeneficiarAdd) {
        return this.http.post(this.storeBeneficiarUrl, beneficiar);
    }

    updateBeneficiar(beneficiar: BeneficiarUpdate) {
        return this.http.put(this.updateBeneficiarUrl, beneficiar);
    }

    deleteBeneficiar(id: number) {
        return this.http.delete(this.deleteBeneficiarUrl + id);
    }

    getBeneficiari() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(this.getBeneficiariUrl)
            .pipe(
                map((response) =>
                    response.data.map((beneficiar) => ({
                        id: beneficiar.id,
                        name: beneficiar.full_name,
                        cnp: beneficiar.cnp,
                    }))
                ),
                catchError((error) => {
                    console.error('Error fetching beneficiari:', error);
                    throw error;
                })
            );
    }

    storeLocalizare(entity_id: number, payload: any) {
        return this.http.post(this.storeLocalizareUrl + entity_id, payload);
    }

    updateLocalizare(localizare_id: number, payload: any) {
        return this.http.patch(this.updateLocalizareUrl + localizare_id, payload);
    }

    deleteLocalizare(localizare_id: number, payload: any) {
        return this.http.patch(this.deleteLocalizareUrl + localizare_id, payload);
    }

    storeRelatie(entity_id: number, payload: any) {
        return this.http.post(this.storeRelatieUrl + entity_id, payload);
    }

    updateRelatie(relatie_id: number, payload: any) {
        return this.http.patch(this.updateRelatieUrl + relatie_id, payload);
    }

    deleteRelatie(relatie_id: number, payload: any) {
        return this.http.patch(this.deleteRelatieUrl + relatie_id, payload);
    }

    storeFiles(entity_id: number, payload: any) {
        return this.http.post(this.storeFilesUrl + entity_id, payload);
    }

    updateFiles(entity_id: number, group_id: number, payload: any) {
        return this.http.patch(this.updateFilesUrl + entity_id + '/' + group_id, payload);
    }

    postMessage(id: number, message: any) {
        return this.http.post(this.postMessageUrl + id, message, this.httpOptions);
    }

    exportHistory(entity_id: number, user_type: number): Observable<Blob> {
        return this.http.get(this.exportHistoryUrl + entity_id + '/' + user_type, {
            responseType: 'blob',
        });
    }

    internalSearch(id: number) {
        return this.http.get(this.internalSearchUrl + id);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
